const CategoriePublicCXPI = [
  'SituationHandicap',
  'BeneficiaireRsaAss',
  'DemandeurEmploiLongueDuree',
  'PublicETTi',
  'ReconnuInapte',
  'SavoirBase',
  'BeneficiaireProtectionInternationale',
  'QualifInferieurCapBep',
  'InactifPlusUnAn',
] as const

const CategoriePublicExtensionCDPI = ['Reconversion', 'CIPIComplet'] as const

export const CategoriePublicCDPI = [...CategoriePublicCXPI, ...CategoriePublicExtensionCDPI] as const

export type CategoriePublicCDPI = (typeof CategoriePublicCDPI)[number]

export const CategoriePublicCIPI = [...CategoriePublicCXPI] as const

export type CategoriePublicCIPI = (typeof CategoriePublicCIPI)[number]

export type CategoriePublic = CategoriePublicCDPI | CategoriePublicCIPI

export const CategoriePublicLibelle: Record<CategoriePublic, string> = {
  SituationHandicap: 'Situation de handicap',
  BeneficiaireRsaAss: 'Bénéficiaire du RSA ou ASS',
  DemandeurEmploiLongueDuree: 'Demandeur d’emploi longue durée',
  PublicETTi: 'Public ETTi',
  ReconnuInapte: 'Reconnu(e) inapte',
  SavoirBase: 'Savoirs de base',
  BeneficiaireProtectionInternationale: 'Bénéficiaire d’une protection internationale et demandeurs d’asile',
  QualifInferieurCapBep: 'Qualification ≤ CAP/BEP + sans expérience',
  InactifPlusUnAn: 'Inactif + d’1 an (non inscrit à Pôle emploi)',
  Reconversion: 'Reconversion',
  CIPIComplet: 'CIPI complet',
} as const

/*
export const CategorieInfOuEgualeQualifInferieurCapBep: CategoriePublic[] = [
  'BeneficiaireRsaAss',
  'DemandeurEmploiLongueDuree',
  'PublicETTi',
  'ReconnuInapte',
  'SavoirBase',
  'BeneficiaireProtectionInternationale',
  'QualifInferieurCapBep',
] as const
*/
